// extracted by mini-css-extract-plugin
export var button = "_ki-0";
export var donut = "_ki-1";
export var donutFill = "_ki-3";
export var donutTrack = "_ki-2";